import React from 'react'

import { Toaster } from 'react-hot-toast'
import { ToastContainer } from 'react-toastify'

import AnnouncementBanner from '@src/components/AnnouncementBanner'
import WalletPortfolioDrawer from '@src/components/WalletPortfolioDrawer'
// import Background from '@src/components/icons/Background'  // no longer needed
import { ConfigLoadingStatus } from '@src/enums'
import { useFetchAllTokens } from '@src/hooks/useFetchAllTokens'
import Footer from '@src/layouts/Footer'
import Header from '@src/layouts/Header'
import { useConfigStore } from '@src/zustand_stores'
import { useApplicationStore } from '@src/zustand_stores/application.store'

interface Props {
    children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }) => {
    const configLoading = useConfigStore(config => config.loading)
    const { isLoading: zustandTokensLoading, error: tokenLoadingError } = useFetchAllTokens()
    const { walletDrawerOpened, openWalletDrawer } = useApplicationStore()

    return (
        <>
            {/* Background gradient */}
            <div className='pointer-events-none absolute -top-[355px] left-1/2 -z-10 h-[770px] w-[770px] max-w-[100vw] -translate-x-1/2 opacity-40 blur-[150px]'>
                <div className='h-full w-full rounded-full bg-gradient-to-b from-[#3C3C3C] to-[#3A3A4D]' />
            </div>

            <AnnouncementBanner className='text-fluid-xs'>
                We’re happy to share that we've launched the Sand Dollar rebate system. Swap now to receive Sand Dollars
                that you can exchange for USDT or USDC.
            </AnnouncementBanner>

            <Header />

            {/* Main content area that will push footer down */}
            <main className='flex flex-grow flex-col items-center font-geist tracking-tightest'>
                {(() => {
                    if (configLoading === ConfigLoadingStatus.loading || zustandTokensLoading) {
                        return <>{children}</>
                    } else if (configLoading === ConfigLoadingStatus.error) {
                        console.error(`FATAL: Unable to load config from server.`)
                        return (
                            <div className='exchange-error-message my-auto text-center text-xl font-medium leading-8 text-red-700'>
                                Our trading system is currently down for maintenance. Please try again soon. [1]
                            </div>
                        )
                    } else if (tokenLoadingError) {
                        console.error(`FATAL: Unable to load list of supported tokens from server.`)
                        return (
                            <div className='exchange-error-message my-auto text-center text-xl font-medium leading-8 text-red-700'>
                                Our trading system is currently down for maintenance. Please try again soon. [2]
                            </div>
                        )
                    }
                    return <>{children}</>
                })()}
            </main>

            {/* Footer will always be at the bottom */}
            <Footer />

            <WalletPortfolioDrawer open={walletDrawerOpened} onClose={() => openWalletDrawer(false)} />
            <ToastContainer />
            <Toaster
                position='bottom-center'
                reverseOrder={false}
                gutter={8}
                toastOptions={{
                    className: '',
                    duration: 5000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                        wordBreak: 'break-word',
                    },
                    success: {
                        duration: 3000,
                    },
                }}
            />
        </>
    )
}

export default Layout
